export const copyingProject = 'copyingProject';
